<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20.456" height="20" viewBox="0 0 20.456 20">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_2369" data-name="Rectangle 2369" width="20.456" height="20" :fill="color"/>
    </clipPath>
  </defs>
  <g id="Group_6086" data-name="Group 6086" clip-path="url(#clip-path)">
    <path id="Path_4494" data-name="Path 4494" d="M10.21,107.241H2.159a1.949,1.949,0,0,1-2.152-2.093c0-1.075.021-2.15-.007-3.224a1.928,1.928,0,0,1,1.925-2.15c1.083-.036,2.169.007,3.253.037a.982.982,0,0,1,.845.54c.226.4.436.81.664,1.21a1.353,1.353,0,0,0,1.236.7q2.3.017,4.6,0a1.459,1.459,0,0,0,1.342-.858c.136-.259.279-.516.4-.783a1.306,1.306,0,0,1,1.257-.854c1.116,0,2.235-.012,3.348.057a1.773,1.773,0,0,1,1.565,1.752c.028,1.272.032,2.546,0,3.818a1.906,1.906,0,0,1-2.078,1.845q-4.073,0-8.147,0" transform="translate(0 -87.242)" :fill="color"/>
    <path id="Path_4495" data-name="Path 4495" d="M3.816,8.118V7.727q0-3.161,0-6.321A1.274,1.274,0,0,1,4.311.243,1.33,1.33,0,0,1,5.67.138a1.206,1.206,0,0,1,.67,1.22c.012,1.46,0,2.921,0,4.381q0,1.017,0,2.034V8.2c.158-.128.257-.2.342-.279.405-.4.8-.811,1.211-1.2a1.379,1.379,0,0,1,1.693-.24,1.2,1.2,0,0,1,.436,1.587,2.48,2.48,0,0,1-.381.5Q7.9,10.284,6.151,12A1.411,1.411,0,0,1,4.015,12C2.832,10.845,1.656,9.681.473,8.524A1.341,1.341,0,0,1,.084,7.04a1.228,1.228,0,0,1,1.774-.587A9.281,9.281,0,0,1,3.038,7.491c.235.216.458.446.686.669l.091-.042" transform="translate(15.317 12.489) rotate(180)" :fill="color"/>
  </g>
</svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#000000',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center_v2/InboxOutIcon.vue